<template>
    <div :class="classNamesElement">
        <label :for="id"><translate>{{ label }}</translate></label>
        <input class="form-input" :type="inputType" :name="id" :id="id" :value="modelValue"
               @input="$emit('update:modelValue', $event.target.value)" ref="input" :placeholder="placeholder"
               :required="required" :autofocus="autofocus" :autocomplete="autocomplete" :disabled="disabled">
        <svg-vue :icon="iconType" class="icon icon--toggle" @click="toggleInput()" />
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>
export default {
    name: 'FormPassword',
    props: [
        'modelValue',
        'id',
        'label',
        'placeholder',
        'required',
        'autofocus',
        'autocomplete',
        'error',
        'info',
        'disabled',
    ],
    computed: {
        classNamesElement() {
            let classNames = ['form-element', 'form-element--icon'];
            if (this.error) classNames.push('form-element--error');
            if (this.modelValue) classNames.push('form-element-filled');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
        inputType() {
            return this.type ? 'text' : 'password';
        },
        iconType() {
            return this.type ? 'eye-cross' : 'eye-open';
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            type: false
        };
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        toggleInput () {
            this.type = !this.type;
        }
    }
};
</script>
